import { cssVariables } from "@/utils/utils";
import { Card, Flex } from "antd";
import CountUp from "react-countup";

type Props = {
  label: React.ReactNode;
  value: number;
  disabled?: boolean;
  color?: string;
};

export const InfoCard = ({ label, value, disabled, color }: Props) => {
  return (
    <Card
      style={{
        height: "100%",
        borderRadius: 18,
        textAlign: "center",
        borderStyle: disabled ? "dashed" : "solid",
        color: disabled ? cssVariables.colorGrey : cssVariables.colorText,
        cursor: disabled ? "not-allowed" : "default",
        backgroundColor: disabled ? cssVariables.colorHover : "white",
      }}
      styles={{ body: { height: "100%", padding: 16 } }}
    >
      <Flex vertical justify="center" style={{ height: "100%", pointerEvents: disabled ? "none" : "auto" }}>
        <div>{label}</div>

        <CountUp
          style={{ marginTop: 8, fontSize: 42, fontWeight: 600, lineHeight: "62px", color: color }}
          duration={4}
          separator={" "}
          end={value}
        />
      </Flex>
    </Card>
  );
};
